export type Job = {
    slug: string
    title: string
    teaser: string
    intro: string[]
    roleIntro: string
    responsibilities: string[]
    lookingFor: string[]
    requirement: string
    offer: string[]
    place: string
    start: string
}

export const JOB_CONTACT = {
    name: 'Ruben Toftdahl',
    role: 'COO',
    email: 'ruben@svenn.com',
    phone: '413 57 243',
    phoneHref: 'tel:+4741357243'
} as const

const COMPANY_INTRO = "Svenn lager programvare for små håndverksbedrifter, med alt fra tilbud og kalkulasjon til prosjektstyring, KS og fakturering. Målet er å hjelpe kundene våre å vinne flere jobber og tjene penger på prosjektene sine. Vi har over 3000 kunder, vokser raskt og oppretter nå denne nye rollen i det kommersielle teamet."

export const JOBS: Job[] = [
    {
        slug: 'expansion-account-executive',
        title: 'Expansion Account Executive',
        teaser: "For deg som liker salg og å lukke avtaler, uten å måtte starte fra scratch hver gang.",
        intro: [
            COMPANY_INTRO,
            "Rollen passer for deg som liker salg og å lukke avtaler, uten å måtte starte fra scratch hver gang."
        ],
        roleIntro: "Du jobber med eksisterende kunder og hjelper dem å få mer ut av Svenn. Customer Success-teamet fanger opp behovene og gir dem videre til deg, og du eier salgsprosessen derfra.",
        responsibilities: [
            "Oppsalg og mersalg til dagens kunder",
            "Bygge sterke kunderelasjoner",
            "Finne nye muligheter hos dagens brukere",
            "Gjennomføre kundemøter og presentere riktige løsninger",
            "Forhandle og lukke avtaler"
        ],
        lookingFor: [
            "Bakgrunn fra salg, account management eller customer success",
            "Trygg i kundedialogen og sterk på relasjoner",
            "Målrettet og resultatorientert",
            "Nysgjerrig og god til å forstå hva kunden trenger",
            "Trives med ansvar og høyt tempo",
            "Erfaring fra håndverksbransjen eller SaaS er et stort pluss"
        ],
        requirement: "Flytende norsk, skriftlig og muntlig.",
        offer: [
            "Et ambisiøst team med høyt tempo, lave skuldre og mye humor i hverdagen",
            "Ansvar og rom for initiativ og nye idéer",
            "Mulighet til å forme en helt ny rolle og arbeidet med kundevekst fremover",
            "Varierte arbeidsdager"
        ],
        place: 'Oslo, Bergen eller remote',
        start: 'Etter avtale'
    },
    {
        slug: 'account-executive-outbound',
        title: 'Outbound Account Executive',
        teaser: "For deg som får energi av jakten på nye kunder, fra første kontakt til signert avtale.",
        intro: [
            "Får du energi av å ta første kontakt, bygge tillit og lukke avtaler?",
            COMPANY_INTRO
        ],
        roleIntro: "Du tar salgsmøtene møtebookerne setter opp, finner nye bedrifter selv, og eier prosessen helt frem til signert avtale.",
        responsibilities: [
            "Gjennomføre salgsmøter som møtebookerne har satt opp, og eie prosessen frem til signert avtale",
            "Jobbe tett med møtebookerne om målgrupper, møtekvalitet og oppfølging",
            "Ta opp igjen kontakten med tidligere leads når timingen passer",
            "Prospektere og kontakte nye bedrifter selv",
            "Presentere Svenn slik at det treffer kundens hverdag",
            "Forhandle og lukke avtaler",
            "Holde styr på egen pipeline og aktivitet i CRM"
        ],
        lookingFor: [
            "Erfaring med B2B-salg, helst nysalg eller outbound",
            "Trygg på å kontakte nye kunder, også på telefon",
            "Strukturert, med kontroll på egen pipeline",
            "Målrettet og motivert av å nå mål",
            "Nysgjerrig og god til å forstå kundebehov",
            "Utholdende, og lar deg ikke slå ut av et nei",
            "Erfaring fra håndverksbransjen eller SaaS er et stort pluss"
        ],
        requirement: "Flytende norsk, skriftlig og muntlig.",
        offer: [
            "Et ambisiøst team med høyt tempo, lave skuldre og mye humor i hverdagen",
            "Ansvar og trivsel i en kultur som verdsetter initiativ og testing av idéer",
            "Mulighet til å bygge opp en ny rolle og påvirke hvordan vi gjør nysalg fremover",
            "Støtte fra møtebookere og et kommersielt team som heier på hverandre",
            "Variert arbeidshverdag"
        ],
        place: 'Oslo, Bergen eller remote',
        start: 'Etter avtale'
    }
]

export const getJob = (slug: string): Job | null => JOBS.find(job => job.slug === slug) ?? null
